import { defineComponent as _defineComponent } from 'vue'
import { Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SalaryLogContent',
  props: {
    content: {}
  },
  setup(__props: any) {

    const props = __props;

    const simpleEntries = computed<[string, unknown][]>(() => {
        if (!props.content) return [];
        try {
            const json = JSON.parse(props.content);
            if (json && typeof json === 'object') {
                return Object.keys(json)
                    .filter((key) => typeof (json as any)[key] !== 'object')
                    .map((key) => [key, (json as any)[key]]);
            }
            return [];
        } catch {
            return [];
        }
    });

    const isJsonRenderable = computed(() => simpleEntries.value.length > 0);

return (_ctx: any,_cache: any) => {
  return (!_ctx.content)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
    : (isJsonRenderable.value)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(simpleEntries.value, ([key, value]) => {
          return (_openBlock(), _createElementBlock("div", { key: key }, [
            _createElementVNode("b", null, _toDisplayString(key) + ":", 1),
            _createTextVNode(" " + _toDisplayString(String(value)), 1)
          ]))
        }), 128))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createTextVNode(_toDisplayString(_ctx.content), 1)
        ], 64))
}
}

})